import React from 'react';
import { useIntl } from 'react-intl';
import { WidgetTableColumnData, WidgetTableColumnsData, WidgetTableColumnTypes } from 'jamespot-user-api';

import { WidgetDatasourceTableContent } from 'jamespot-user-api';

import { JRCButtonDropdown, JRCButtonDropdownOptionProps } from 'index';

import { SUPPORTED_LABELIZE_TYPE } from '../const';

export const WidgetDatasourceModelViewColumnAction = ({
    type,
    tableColumnsData,
    item,
    handleEditLabel,
    onChange,
}: {
    type: WidgetTableColumnTypes;
    tableColumnsData: WidgetTableColumnsData;
    item: WidgetTableColumnData;
    handleEditLabel: () => void;
    onChange: (content: Partial<WidgetDatasourceTableContent>, override?: boolean) => void;
}) => {
    const intl = useIntl();
    const options: JRCButtonDropdownOptionProps[] = [];

    options.push({
        label: intl.formatMessage({ id: 'WIDGET_Table_Text_Ellipsis' }),
        onClick: () => {
            onChange({
                tableColumnsData: tableColumnsData.map((el) =>
                    el.name === item.name ? { ...el, textEllipsis: !item.textEllipsis } : el,
                ),
            });
        },
        ...(item.textEllipsis
            ? {
                  icon: {
                      name: 'icon-check',
                      color: 'green',
                  },
              }
            : {}),
    });

    if (SUPPORTED_LABELIZE_TYPE.includes(type)) {
        options.push({
            label: intl.formatMessage({ id: 'WIDGET_Table_Edit_Label' }),
            onClick: () => handleEditLabel(),
            ...(item.label
                ? {
                      icon: {
                          name: 'icon-check',
                          color: 'green',
                      },
                  }
                : {}),
        });
    }

    return (
        <JRCButtonDropdown
            small
            smallOpenDirection="left"
            options={options}
            icon={'icon-ellipsis-v'}
            label={'...'}
            color={'secondary'}
            variant="outlined"
        />
    );
};
